import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import BinIcon from '../../../components/icon/IconWrapped';
import React, { Fragment } from 'react';
import moment from 'moment';
import amountFormat from '../../../utils/amountFormat';
import { USER_STATUSES_NAMES } from '../userStatusesConstants';
import { CashbackRowStyled } from './styled/UserStatusCashbackClickInfo';
import UserStatusWidgetWrapper from './UserStatusWidgetWrapper';
import { getLocationPlatformSelector } from '../../Location/locationSelectors';
import { useSelector } from 'react-redux';
import { LOCATION_PLATFORM } from '../../Location/locationConstants';

interface IUserStatusCashbackClickInfoProps {
    children?: JSX.Element | JSX.Element[];
}

const levels = [
    { status: USER_STATUSES_NAMES.FREE, amount: 0 },
    { status: USER_STATUSES_NAMES.STANDARD, amount: 0 },
    { status: USER_STATUSES_NAMES.BRONZE, amount: 0 },
    { status: USER_STATUSES_NAMES.SILVER, amount: 1 },
    { status: USER_STATUSES_NAMES.GOLD, amount: 2.5 },
    { status: USER_STATUSES_NAMES.PLATINUM, amount: 5 },
    { status: USER_STATUSES_NAMES.ROYAL, amount: 7.5 },
];

function UserStatusCashbackClickInfo(props: IUserStatusCashbackClickInfoProps) {
    const {
        children,
    } = props;

    return <UserStatusWidgetWrapper
        toggleComponent={children}
        widgetName={'cashback'}
    >
        <UserStatusCashbackClickInfoInner/>
    </UserStatusWidgetWrapper>;
}

export function UserStatusCashbackClickInfoInner() {
    const { getLangPath } = useLangContext();
    const platform = useSelector(getLocationPlatformSelector);
    const isDesktop = platform === LOCATION_PLATFORM.DESKTOP;
    const iconSize = isDesktop ? 80 : 32;

    return <div className={'d-flex flex-column font-size-14'}>
        <div className={'text-center'}><BinIcon name={'IcCashback'} size={iconSize} className={'mb-2'}/></div>
        <div className={'text-secondary text-center'}>{getLangPath('user_statuses.cashback.title')}</div>
        <div className={'align-self-start mt-3'}>{getLangPath('user_statuses.cashback.description')}</div>
        <div className={'surface-secondary shadow-primary mt-3'}>
            <div className="text-secondary">{getLangPath('user_statuses.cashback.next_date')}</div>
            <div
                className={'fw600'}>{moment().startOf('month').add(1, 'month').format(getLangPath('format.date'))}</div>
        </div>
        <div className={'surface-secondary shadow-primary mt-3'}>
            <div className="text-secondary">{getLangPath('user_statuses.cashback.max_amount')}</div>
            <div className={'fw600'}>{amountFormat(100, 0, '$')}</div>
        </div>
        <div className={'surface-secondary shadow-primary mt-3'}>
            <CashbackRowStyled className={'fw600'}>
                <div>{getLangPath('user_statuses.cashback.table_levels')}</div>
                <div>{getLangPath('user_statuses.cashback.table_cashback')}</div>
            </CashbackRowStyled>
            {
                levels.map((item) => <Fragment key={item.status}>
                    <CashbackRowStyled className={'text-secondary'}>
                        <div>{getLangPath(`user_statuses.statuses.${item.status}.title`)}</div>
                        <div>{item.amount ? amountFormat(item.amount, 1, null, false, {
                            currencyAfter: '%',
                        }) : '-'}</div>
                    </CashbackRowStyled>
                </Fragment>)
            }
        </div>
    </div>
}

export default UserStatusCashbackClickInfo;
